import { Fragment } from 'react'
import {
  createTheme,
  ThemeProvider,
  Box,
  Badge,
  Radio,
  Fade,
  Tooltip
} from '@mui/material'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import { Link, useNavigate } from 'react-router-dom'
import ItemQuantityContainer from '../../containers/ItemQuantityContainer/ItemQuantityContainer.jsx'
import SuggestedProducts from '../SuggestedProducts/SuggestedProducts.jsx'
import { formatter } from '../../utils/auxFunc'
import './ItemDetail.css'
import VolumeDiscount from '../VolumeDiscount/VolumeDiscount.jsx'

const theme = createTheme()

theme.typography.body1 = {
  fontSize: '1rem',
  '@media (min-width:600px)': {
    fontSize: '1rem'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1rem'
  }
}

theme.typography.h3 = {
  fontSize: '1rem',
  '@media (min-width:600px)': {
    fontSize: '1rem'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1rem'
  }
}

const BpIcon = styled('span')({
  borderRadius: '50%',
  width: 30,
  height: 30
})

const BpCheckedIcon = styled(BpIcon)({
  border: 'solid 2px white',
  boxShadow: '0 0 15px 10px white'
})

const ItemDetail = ({
  throttle,
  showPriceAndLogin,
  getInitialValue,
  handleProductsToAddToCart,
  handleAddToCart,
  product,
  sizesByColor,
  handleClickColor,
  componentColor,
  isDisabled,
  getQuantityByColor,
  handleChangeImg,
  changeImgInEachColor,
  imgIndex
}) => {
  const navigate = useNavigate()

  return componentColor !== undefined ? (
    <Fragment>
      <Box className="itemDetailContainer" maxWidth={1200}>
        <button className="btnBackItemDetail" onClick={() => navigate(-1)}>
          <ArrowBackIcon className="iconSizeGuide" />
        </button>
        <Box className="cardContainer" maxWidth={1200}>
          <Box className="imgContainer">
            <Box className="boxBtnsAndImg">
              <Box className="boxButtonsBack">
                <button
                  className="btnChangeImgBack"
                  onClick={() => {
                    handleChangeImg(imgIndex - 1)
                  }}
                  disabled={imgIndex === 0 ? true : false}
                >
                  <ArrowBackIosNewIcon />
                </button>
              </Box>
              <Card sx={{ boxShadow: 'none' }}>
                {changeImgInEachColor.img !== '' ? (
                  <CardMedia
                    component={
                      changeImgInEachColor.img.match(
                        '^.*.(jpg|gif|png|jpeg|webp)$'
                      )
                        ? 'img'
                        : 'iframe'
                    }
                    scrolling="no"
                    image={changeImgInEachColor.img}
                    alt={product.name}
                    className="imgCard"
                  />
                ) : (
                  <CardMedia
                    component={
                      product.img.match('^.*.(jpg|gif|png|jpeg|webp)$')
                        ? 'img'
                        : 'iframe'
                    }
                    scrolling="no"
                    image={componentColor.imgC[0].img}
                    alt={product.name}
                    className="imgCard"
                  />
                )}
              </Card>
              <Box className="boxButtonForward">
                <button
                  className="btnChangeImgFoward"
                  onClick={() => {
                    handleChangeImg(imgIndex + 1)
                  }}
                  disabled={
                    imgIndex === componentColor?.imgC?.slice(0, 3).length
                      ? true
                      : false
                  }
                >
                  <ArrowForwardIosIcon />
                </button>
              </Box>
            </Box>
            <Box className="boxBtnHandleChangeImg">
              {changeImgInEachColor?.img === ''
                ? componentColor?.imgC?.slice(0, 4).map((img, index) => (
                    <Button
                      className="btnHandleChangeImg"
                      sx={{
                        borderRadius: '100%',
                        minWidth: 0,
                        width: '10px',
                        height: '10px',
                        margin: '5px',
                        border: 'transparent',
                        backgroundColor: index === 0 ? '#29343f' : '#ced4da',
                        paddingTop: '10px',
                        '&:hover': {
                          backgroundColor: '#6f7275'
                        }
                      }}
                      onClick={() => {
                        handleChangeImg(index)
                      }}
                      key={index}
                    ></Button>
                  ))
                : componentColor?.imgC?.slice(0, 4).map((img, index) => (
                    <Button
                      className="btnHandleChangeImg"
                      sx={{
                        borderRadius: '100%',
                        minWidth: 0,
                        width: '10px',
                        height: '10px',
                        margin: '5px',
                        border: 'transparent',
                        backgroundColor:
                          changeImgInEachColor?.img === img.img
                            ? '#29343f'
                            : '#ced4da',
                        paddingTop: '10px',
                        '&:hover': {
                          backgroundColor: '#6f7275'
                        }
                      }}
                      onClick={() => {
                        handleChangeImg(index)
                      }}
                      key={index}
                    ></Button>
                  ))}
            </Box>
          </Box>
          <Box className="detailContainer">
            <CardContent>
              <ThemeProvider theme={theme}>
                <Box className="typographyItemDetail">
                  <Typography variant="h3" style={{ fontFamily: 'Quicksand' }}>
                    {product?.name}
                  </Typography>
                  <Typography variant="h3" style={{ fontFamily: 'Quicksand' }}>
                    {`SKU: ${
                      product.components.find(
                        (component) =>
                          component.idComponent ===
                          componentColor.types[0].idComponent
                      )?.sku
                    }`}
                  </Typography>

                  {!product.isPromotion ? (
                    <Typography
                      variant="h3"
                      style={{ fontFamily: 'Quicksand' }}
                    >
                      {showPriceAndLogin &&
                        formatter().format(
                          product?.price * product?.dolarValue
                        )}
                    </Typography>
                  ) : (
                    <Box className="price-box-itemDetail">
                      <Typography
                        variant="h3"
                        style={{ fontFamily: 'Quicksand' }}
                        className="price-itemDetail"
                      >
                        {showPriceAndLogin &&
                          formatter().format(
                            product?.markedPrice * product?.dolarValue
                          )}
                      </Typography>
                      <Typography
                        variant="h3"
                        style={{ fontFamily: 'Quicksand' }}
                        sx={{ ml: 2 }}
                        color="red"
                      >
                        {showPriceAndLogin &&
                          formatter().format(
                            product?.price * product?.dolarValue
                          )}
                      </Typography>
                    </Box>
                  )}
                </Box>
                <pre>
                  <Typography
                    className="typographyItemDetailDescription"
                    variant="body1"
                    color="text.secondary"
                  >
                    {`${product?.description}`}
                  </Typography>
                </pre>
              </ThemeProvider>
              {product.volumePrices?.some(
                (condition) => condition.minQuantity > 0 && condition.price > 0
              ) && (
                <VolumeDiscount
                  conditions={product.volumePrices}
                  dolarValue={product.dolarValue}
                />
              )}
              {/* <VolumeDiscount conditions={product.volumePrices} /> */}
            </CardContent>
            {showPriceAndLogin ? (
              <Fragment>
                <Box className="sliderItemDetail" sx={{ display: 'flex' }}>
                  {sizesByColor.map((colors) => (
                    <Box key={colors.descriptionColor}>
                      {colors.descriptionColor !== '' && (
                        <Tooltip
                          title={colors.descriptionColor}
                          placement="bottom"
                          TransitionComponent={Fade}
                          TransitionProps={{ timeout: 600 }}
                          sx={{
                            textTransform: 'capitalize',
                            fontSize: '5rem'
                          }}
                        >
                          <Badge
                            className="paletteColor"
                            style={{ background: `#${colors.colorHexa}` }}
                            onClick={() => {
                              handleClickColor(colors.descriptionColor)
                            }}
                            max={9999}
                            overlap="circular"
                            badgeContent={getQuantityByColor(
                              colors.descriptionColor
                            )}
                            sx={{
                              '& .MuiBadge-badge': {
                                color: 'white',
                                backgroundColor: 'black',
                                border: 'solid 1px white'
                              }
                            }}
                          >
                            <Radio
                              checked={
                                componentColor?.descriptionColor ===
                                colors.descriptionColor
                              }
                              value={colors.descriptionColor}
                              checkedIcon={
                                componentColor?.descriptionColor ===
                                'blanco' ? (
                                  <BpCheckedIcon
                                    style={{
                                      backgroundColor: `#${colors.colorHexa}`,
                                      border: 'solid 2px lightgrey',
                                      boxShadow: '0 0 8px 6px lightgrey'
                                    }}
                                  />
                                ) : (
                                  <BpCheckedIcon
                                    style={{
                                      backgroundColor: `#${colors.colorHexa}`
                                    }}
                                  />
                                )
                              }
                              icon={
                                <BpIcon
                                  style={{
                                    background: `#${colors.colorHexa}`
                                  }}
                                />
                              }
                              onClick={() => {
                                handleClickColor(colors.descriptionColor)
                              }}
                            />
                          </Badge>
                        </Tooltip>
                      )}
                    </Box>
                  ))}
                </Box>
                {componentColor?.descriptionColor && (
                  <Typography
                    className="sizeTextColor"
                    variant="body1"
                    color="text.secondary"
                    sx={{ paddingLeft: '16px' }}
                  >
                    Color: {componentColor?.descriptionColor}
                  </Typography>
                )}

                <CardActions className="cardActionsSizesContainer">
                  {componentColor?.types?.map((item) => (
                    <Fragment key={item.idComponent}>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-around',
                          alignItems: 'center',
                          p: 1,
                          m: 1,
                          bgcolor: 'background.paper',
                          borderRadius: 1,
                          width: '100%'
                        }}
                      >
                        <Box>
                          <ItemQuantityContainer
                            component={item}
                            initial={getInitialValue(item.idComponent)}
                            handleProductsToAddToCart={
                              handleProductsToAddToCart
                            }
                          />
                        </Box>
                      </Box>
                    </Fragment>
                  ))}
                </CardActions>
                <CardActions className="cardActionsButton">
                  <Button
                    className="btnAddToCart"
                    style={{
                      fontFamily: 'Quicksand',
                      background: !isDisabled
                        ? '#E60B13'
                        : 'rgba(0, 0, 0, 0.26)'
                    }}
                    variant="contained"
                    color="secondary"
                    disabled={isDisabled}
                    fullWidth
                    sx={{
                      mt: 0.0,
                      fontSize: '1rem',
                      fontWeight: 700,
                      textTransform: 'none',
                      textAlign: 'center'
                    }}
                    onClick={throttle(handleAddToCart, 1000)}
                  >
                    Agregar al carrito
                  </Button>
                </CardActions>
              </Fragment>
            ) : (
              <CardActions className="cardActionsButton">
                <Link
                  to="/login"
                  style={{
                    textDecoration: 'none'
                  }}
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    sx={{
                      mt: 0.0,
                      fontSize: '1rem',
                      fontWeight: 700,
                      textTransform: 'none',
                      textAlign: 'center'
                    }}
                  >
                    Iniciar sesión
                  </Button>
                </Link>
              </CardActions>
            )}
            <ThemeProvider theme={theme}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <Typography
                  className="shippingMethods"
                  sx={{ display: 'flex', alignItems: 'center', ml: 1 }}
                  style={{ fontFamily: 'Quicksand' }}
                >
                  <LocalShippingIcon className="iconItemDetail" />
                  Medios y formas de envío
                </Typography>
              </Box>
            </ThemeProvider>
          </Box>
        </Box>
        {product.webRelatedProducts?.length > 0 ? (
          <Box className="suggestedProductsBox">
            <Typography
              variant="h2"
              mt={3}
              mb={3}
              ml={2}
              style={{ fontFamily: 'Quicksand' }}
            >
              <strong>Productos Sugeridos</strong>
            </Typography>
            <SuggestedProducts
              product={product}
              showPriceAndLogin={showPriceAndLogin}
            />
          </Box>
        ) : (
          ''
        )}
      </Box>
    </Fragment>
  ) : (
    <Box className="noStock">
      <Typography variant="h1">
        Producto sin stock o búsqueda inexistente
      </Typography>
      <Typography variant="h3">
        Verifique ingresar correctamente el código o nombre del producto
      </Typography>
      <Typography variant="h3">
        Consultanos cuando estarán disponibles.
      </Typography>
    </Box>
  )
}

export default ItemDetail
